"use client";

import { useContext, useEffect, useRef, useState } from "react";
import {observer} from "mobx-react";

import classNames from "classnames";
import styles from "./styles/SidebarContainer.module.scss";

import FontAwesome from "../../utilities/FontAwesome";
import LoginButtons from "./items/LoginButtons";
import {StoreContext} from "../../../stores/StoreContext";
import dynamic from 'next/dynamic';
import {FetchMachine} from "../../machines/FetchMachine";
import {useMachine} from '@xstate/react';
import SidebarContainer from "./SidebarContainer";
import Button from "../../utilities/Button";

const SidebarComponent = {
    "pagesettings": dynamic(() => import("./pages/SidebarNavPage"), {loading: () => <></>}),
    "gridsettings": dynamic(() => import("./pages/SidebarGridSettingsPage"), {loading: () => <></>}),
    "Social": dynamic(() => import("./pages/SidebarSocialPage"), {loading: () => <></>}),
    "appearance": dynamic(() => import("./pages/SidebarAppearancePage"), {loading: () => <></>}),
    "Domain": dynamic(() => import("./pages/SidebarDomainPage"), {loading: () => <></>}),
    "Navigation": dynamic(() => import("./pages/SidebarPagesPage"), {loading: () => <></>}),
    "AddSocial": dynamic(() => import("./pages/AddNewSourcePage"), {loading: () => <></>}),
    "ClaimLogin": dynamic(() => import('./claim/ClaimLogin'), {loading: () => <></>}),
    "VerifyOwnership": dynamic(() => import("./claim/VerifyOwnership"), {loading: () => <></>}),
    'NoPhone': dynamic(() => import('./claim/NoPhone'), {loading: () => <></>}),
    'Scheduler': dynamic(() => import('./claim/Scheduler'), {loading: () => <></>}),
    'VerifyByPhone': dynamic(() => import('./claim/VerifyByPhone'), {loading: () => <></>}),
    'VerifyByEmail': dynamic(() => import('./claim/VerifyByEmail'), {loading: () => <></>}),
    "EditSource": dynamic(() => import("./pages/EditSourcePage"), {loading: () => <></>}),
    "ViewSourceType": dynamic(() => import('./pages/ViewSourceTypePage'), {loading: () => <></>}),
    "EditLocation": dynamic(() => import('./pages/EditLocationPage'), {loading: () => <></>}),
    "FixSource": dynamic(() => import('./pages/FixSourcePage'), {loading: () => <></>}),
    "EditAddress": dynamic(() => import('./pages/EditAddressPage'), {loading: () => <></>}),
    "ErrorPage": dynamic(() => import("./pages/ErrorPage"), {loading: () => <></>}),
    "SchoolFeedPost": dynamic(() => import("./pages/SchoolFeedPostPage"), {loading: () => <></>}),
    "PublishDeletePage": dynamic(() => import("./pages/PublishDeletePage"), {loading: () => <></>}),
};

const DisplayText = {
    "gridsettings": "Grid Options",
    "Social": "Social Feeds",
    "Navigation": "Navigation",
    "Design": "Design",
    "Domain": "Domain",
    "pagesettings": "Page Settings",
    "AddSocial": "Add Content Feed",
    "ClaimLogin": null,
    "EditSource": "Feed Status Report",
    "ViewSourceType": null,
    "VerifyByEmail": "Back",
    "VerifyByPhone": "Back",
    "EditLocation": "Back",
    "SchoolFeedPost": "Back"
};

const topNavButtonClassName = classNames({
    [styles.topNavButton]: true,
});
const noAccessContainerClassName = classNames({
    [styles.noAccessContainer]: true,
});
const sidebarHeaderClassName = classNames({
    [styles.sidebarHeader]: true,
});

const AdminSidebar = observer(() => {
    const {userStore, organizationStore, sidebarStore, interfaceStore} = useContext(StoreContext);

    const [currentComponent, setCurrentComponent] = useState("");
    const [current, send] = useMachine(FetchMachine);
    const containerRef = useRef(null);

    useEffect(() => {
        if (sidebarStore.sidebar) {
            const view = sidebarStore.sidebar.view;
            setCurrentComponent(view);

            if (containerRef?.current) {
                containerRef.current.scrollTop = 0;
            }
        } else if (currentComponent) {
            setCurrentComponent(null);
        }
    }, [sidebarStore.sidebar]);

    useEffect(() => {
        const contentContainer = document.querySelector("#sb-content-canvas");
        const modalContainer = document.querySelector("#allModalContainer");

        async function handleClick(e) {
            if (currentComponent && !modalContainer.contains(e.target)) {
                await sidebarStore.close();
            }
        }

        if (contentContainer) {
            contentContainer.addEventListener("click", handleClick);
        }
        return () => {
            if (contentContainer) {
                contentContainer.removeEventListener("click", handleClick);
            }
        }
    }, [])

    const ComponentToDisplay = currentComponent ? SidebarComponent[currentComponent] : () => <div/>;

    return <SidebarContainer ref={containerRef} in={!!currentComponent}>
        <div className={sidebarHeaderClassName}>
            {sidebarStore.historyStack.length > 1 &&
            <Button className={topNavButtonClassName}
                    onClick={sidebarStore.back}
                    title={'Back'}>
                <FontAwesome ariaHidden={true} prefix={'fas'} name="fa-chevron-left"/>
                <h3>{DisplayText[sidebarStore.historyStack[sidebarStore.historyStack.length - 2]?.view]}</h3>
            </Button>}

        </div>
        {(userStore.isEditor || interfaceStore.view === 'schoolfeed') ?
            <ComponentToDisplay currentSourceLoadingState={current} sendSourceLoadingState={send}/> :
            <div className={noAccessContainerClassName}>
                <p style={{textAlign: 'center'}}>
                    Please login below to access admin panel
                </p>
                <LoginButtons/>
            </div>}
    </SidebarContainer>
});

export default AdminSidebar;
